import { Product } from 'types/Product';
import { useEffect } from 'react';
import { chunksOf } from 'fp-ts/lib/Array';
import { useDispatch, useSelector } from 'react-redux';
import { Category } from 'types/Category';
import { setProducts } from 'store/ui/actions';
import { paginationStateSelector } from 'store/ui/selectors';
import { ProductGridProduct } from 'components/ProductGrid';

// Magento Product Visibility Constants
// Const VISIBILITY_NOT_VISIBLE = "1"
// Const VISIBILITY_SEARCH = "3"

const VISIBILITY_CATALOG = '2';
const VISIBILITY_CATALOG_AND_SEARCH = '4';

const isVisibleInCatalog = (product: Product) =>
  [VISIBILITY_CATALOG, VISIBILITY_CATALOG_AND_SEARCH].includes(product.visibility);

type OnPaginationChange = (productIds: number[]) => void;
const defaultOnPaginationChange: OnPaginationChange = (productIds: number[]) => {};
type PaginationReturnType = {
  productPages: ProductGridProduct[][];
  currentPage: number;
}
export function usePagination(category: Category, onPaginationChange = defaultOnPaginationChange): PaginationReturnType {
  const visibleProducts = category.products.filter(isVisibleInCatalog);

  const { currentPage, displayCount } = useSelector(paginationStateSelector);
  const productPages = chunksOf<ProductGridProduct>(displayCount)(visibleProducts);
  const dispatch = useDispatch();

  useEffect(() => {
    if (category.categoryId !== null) {
      dispatch(setProducts(visibleProducts));
    }
  }, [dispatch, visibleProducts, category.categoryId]);

  useEffect(() => {
    if (productPages[currentPage]) {
      const productIds = productPages[currentPage].slice(0, 3).map(product => product.productId);
      onPaginationChange(productIds);
    }
  }, [onPaginationChange, productPages, currentPage]);

  return { productPages, currentPage };
}
